import { useLike } from '@/hooks/useLike'
import classNames from 'classnames'
import { Like } from '@vhl/icons/post'
import { useToggle } from 'react-use'

interface LikeButtonProps {
  postId: number
  direction?: 'row' | 'column'
  iconColor?: string
  iconLikedColor?: string
  textColor?: string
  textLikedColor?: string
}

const LikeButton = ({
  postId,
  direction = 'row',
  iconColor = 'stroke-gray-300',
  iconLikedColor = 'fill-blue-500 stroke-white',
  textColor = 'text-gray-300',
  textLikedColor = 'text-blue-500',
}: LikeButtonProps) => {
  const { likes, isUserLiked, handleLike } = useLike(postId)
  const [isClicked, toggleClicked] = useToggle(false)
  const boxClass = classNames(
    'flex items-center cursor-pointer relative transition duration-150 group',
    {
      'space-x-2': direction === 'row',
      'flex-col space-y-1': direction === 'column',
      'scale-110': isClicked,
    }
  )
  const iconClass = classNames(
    'transition duration-300 group-hover:stroke-blue-500',
    {
      [iconColor]: !isUserLiked,
      [iconLikedColor]: isUserLiked,
    }
  )
  const textClass = classNames(
    `absolute font-bold text-form font-heading ${textColor} group-hover:${textLikedColor} transition duration-300 ease-in-out`,
    {
      'left-7': direction === 'row',
      'top-6': direction === 'column',
    }
  )
  return (
    <div
      className={boxClass}
      onClick={() => {
        toggleClicked()
        setTimeout(() => toggleClicked(false), 150)
      }}
    >
      <Like width={32} height={32} className={iconClass} onClick={handleLike} />
      <p className={textClass}>{likes}</p>
    </div>
  )
}

export default LikeButton
